import { viperApi, clinicalApiPath } from '@/services/viper-api'
import * as qs from 'qs'

export const biomarkerService = {
  basePath: `${clinicalApiPath}/biomarkers`,

  getBiomarkers(params) {
    return viperApi.get(this.basePath, {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { allowDots: true, arrayFormat: 'comma' })
      }
    })
  },

  getBiomarkerMethods(params) {
    return viperApi.get(this.basePath + '/methods', {
      params,
      paramsSerializer: paramsSerializer
    })
  },

  getBiomarkerMethodResults(params) {
    return viperApi.get(this.basePath + '/method-results', {
      params,
      paramsSerializer: paramsSerializer
    })
  }
}

function paramsSerializer(params) {
  return qs.stringify(params, { allowDots: true, arrayFormat: 'comma' })
}
